import type { CalendarMenuProps } from './types/calendar-menu.props';

import MailingTypeMenu from './mailing-type-menu';

const CalendarMenu = ({ isActive }: CalendarMenuProps) => {
  return (
    <MailingTypeMenu
      isActive={isActive}
      label="Calendar"
      pathSegment="calendar"
    />
  );
};

export default CalendarMenu;
